import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../app/modules/auth';
import { checkMenuByPermissions } from '../../app/modules/utils/FunctionUtils';
import { allMenu } from '../../app/pages/Homepage/listMenu';
import { DrawerComponent, MenuComponent, ScrollComponent, StickyComponent, SwapperComponent, ToggleComponent } from '../assets/ts/components';
import { ThemeModeProvider } from '../partials';
import { Content } from './components/content';
import { OctHeaderWrapper, OctSidebar } from '@oceantech/oceantech-ui';
import { PageDataProvider } from './core';

const MasterLayout = () => {
	const { logout } = useAuth();
	const location = useLocation();
	const MENU_DEFAULT = allMenu[0].subMenu;
	const menuByPermissions = checkMenuByPermissions(MENU_DEFAULT);
	const menus = !menuByPermissions.length ? [] : getMenus(menuByPermissions);

	useEffect(() => {
		// Defer re-initialization to when browser is idle
		// Only re-init when actually needed (pathname changes, not every route key change)
		const reinitComponents = () => {
			MenuComponent.reInitialization();
			ToggleComponent.reInitialization();
			DrawerComponent.reInitialization();
			StickyComponent.reInitialization();
			ScrollComponent.reInitialization();
			SwapperComponent.reInitialization();
		};

		// Use requestIdleCallback to avoid blocking main thread
		if ('requestIdleCallback' in window) {
			const handle = requestIdleCallback(reinitComponents, { timeout: 500 });
			return () => cancelIdleCallback(handle);
		} else {
			// Fallback for browsers without requestIdleCallback
			const timeoutId = setTimeout(reinitComponents, 50);
			return () => clearTimeout(timeoutId);
		}
	}, [location.pathname]); // ✅ Only when pathname changes, not every navigation

	function getMenus(menus: any[]): any[] {
		return menus.map((menu: any) => {
			return {
				...menu,
				name: menu.title,
				uri: menu.to,
				subs: menu?.subMenu && getMenus(menu.subMenu),
			};
		});
	};

	return (
		<PageDataProvider>
			<ThemeModeProvider>
				<div className="d-flex flex-column flex-root app-root" id="kt_app_root">
					<div className="app-page flex-row flex-row-fluid" id="kt_app_page">
						<OctSidebar menus={menus} />
						<div className="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
							<OctHeaderWrapper
								onLogout={logout}
								menuOptions={menus}
								hasIntl
								hasCache
							/>
							<div
								className="app-main flex-column flex-row-fluid justify-content-between"
								id="kt_app_main"
							>
								<div className="d-flex flex-column flex-column-fluid">
									<Content>
										<Outlet />
									</Content>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ThemeModeProvider>
		</PageDataProvider>
	);
};

export { MasterLayout };

